export const durationSelectItems = [
    { name: '15m', key: '15', durationMin: 15 },
    { name: '30m', key: '30', durationMin: 30 },
    { name: '45m', key: '45', durationMin: 45 },
    { name: '60m', key: '60', durationMin: 60 },
];

export const eventTypeItems = [
    { label: 'Phone Call', value: 'Phone Call' },
    { label: 'Video Meeting', value: 'Video Meeting' },
    { label: 'In-Person Session', value: 'In-Person Session' },
];

export const noEmailErrorMessages = {
    patientWithNoEmail:
        'No email confirmation will be sent. No email address on file or patient has opted out of appointment notification emails.',
    patientUnderAge: 'No email confirmation will be sent. Patient must be 18 or older for confirmation emails.',
};

export const ageOfmajority = 18;
